import React, { useCallback, useLayoutEffect, useState } from "react";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import { CommonSelect, CstmPagination } from "components/Common/Common";
import { Link, useNavigate } from "react-router-dom";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { MANAGE_COORDINATORS_ADD, MANAGE_COORDINATORS_EDIT } from "config/paths";
import { dateFormat, successMessageToast } from "helpers/common";
import LoadingOverlay from "components/shared/LoadingOverlay";
import ErrorComponent from "components/shared/ErrorComponent";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { useArchiveTeacherMutation } from "store/services/archive";
import { useDispatch, useSelector } from "react-redux";
import { coordinatorsFilter } from "store/slices/filter";
import AlertPop from "components/Modals/AlertPop";
import { useResendTeacherInviteMutation } from "store/services/guardian";
import { useDeleteCoordinatorMutation, useGetCoordinatorsListQuery } from "store/services/coordinators";
import TableLayoutV2 from "components/TableLayoutV2";
import { debounce } from "lodash";
import { STATUS_OPTIONS } from "config/constants";

const ManageCoordinators = () => {

    const navigate = useNavigate();

    const dispatch = useDispatch();
    const filter = useSelector(state => state?.filter?.coordinatorsFilter);

    const [modalType, setModalType] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [currentEntry, setCurrentEntry] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [coordinatorsList, setCoordinatorsList] = useState([]);
    const [showAlertModal, setShowAlertModal] = useState(false);

    const [archiveCoordinator, { isLoading: archiveCoordinatorLoading }] = useArchiveTeacherMutation();
    const [deleteCoordinator, { isLoading: deleteCoordinatorLoading }] = useDeleteCoordinatorMutation();
    const { data, isLoading, isError, isFetching, refetch } = useGetCoordinatorsListQuery({ page: currentPage, limit: pageSize, ...filter });
    const totalRecords = data?.totalRecords || 0;
    const totalPages = Math.ceil(totalRecords / pageSize);
    const [resendAccountActivation, { isLoading: resendMailLoading }] = useResendTeacherInviteMutation();

    const handleDelete = async () => {

        try {

            setShowModal(false);

            const list = [...coordinatorsList];
            const index = coordinatorsList?.findIndex(x => x.id === currentEntry?.id);
            delete list[index];
            setCoordinatorsList(list.filter(Boolean));

            const result = await deleteCoordinator(currentEntry?.id);
            if (!result?.error) successMessageToast(result?.data?.message);

        } catch (err) { console.error("error deleting parent", err); };
    };

    const column = [
        {
            head: "Last Name",
            accessor: "lastname",
            isComponent: true,
            sorter: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-bold themeBlue">{item?.lastname || "--"}</h6>
            ),
        },
        {
            head: "First Name",
            accessor: "firstname",
            isComponent: true,
            sorter: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-bold themeBlue">{item?.firstname || "--"}</h6>
            ),
        },
        {
            head: "Phone Number",
            accessor: "phone",
            sorter: true,
            component: (item, ind) => (
                <p>{item?.phone || "--"}</p>
            ),
        },
        {
            head: "Email",
            accessor: "email",
            isComponent: true,
            sorter: true,
            component: (item, ind) => (
                <p className="cell-text-ellipsis">{item?.email || "--"}</p>
            ),
        },
        {
            head: "Status",
            accessor: "status",
            sorter: true,
            isComponent: true,
            component: (item, ind) => (
                <p
                    style={{ width: 80 }}
                    className={`${item.status == "active"
                        ? "greenStatus"
                        : "redStatus"
                        } status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
                >
                    {item.status}
                </p>
            ),
        },
        {
            head: "Activation Date",
            accessor: "selectAll",
            isComponent: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-bold themeBlue">{item?.createdAt ? dateFormat(item?.createdAt, "MMM DD, YYYY") : "--"}</h6>
            ),
        },
        {
            head: "Action",
            accessor: "",
            isComponent: true,
            component: (item) => (
                <>
                    <div className="ActnBtn d-flex align-items-center  gap-10">
                        <Dropdown
                            onClick={(e) => e.stopPropagation()}
                        // show={index == dropdownIndex}
                        // onToggle={() => setDropdownIndex(index == dropdownIndex ? null : index)}
                        >
                            <Dropdown.Toggle
                                variant="transparent"
                                className="p-0 border-0 text-dark w-100"
                                id="dropdown-basic"
                            >
                                <span className="icn ">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="28"
                                        height="13"
                                        viewBox="0 0 28 13"
                                        fill="none"
                                    >
                                        <rect width="28" height="13" rx="6.5" fill="" />
                                        <path
                                            d="M23.2678 4.73223C22.2915 3.75592 20.7085 3.75592 19.7322 4.73223C18.7559 5.70854 18.7559 7.29146 19.7322 8.26777C20.7085 9.24408 22.2915 9.24408 23.2678 8.26777C24.2441 7.2915 24.2441 5.70858 23.2678 4.73223Z"
                                            fill="#8f8f8f"
                                        />
                                        <path
                                            d="M16.2678 4.73223C15.2915 3.75592 13.7085 3.75592 12.7322 4.73223C11.7559 5.70854 11.7559 7.29146 12.7322 8.26777C13.7085 9.24408 15.2915 9.24408 16.2678 8.26777C17.2441 7.2915 17.2441 5.70858 16.2678 4.73223"
                                            fill="#8f8f8f"
                                        />
                                        <path
                                            d="M9.26777 4.73223C8.29146 3.75592 6.70854 3.75592 5.73223 4.73223C4.75592 5.70854 4.75592 7.29146 5.73223 8.26777C6.70854 9.24408 8.29146 9.24408 9.26777 8.26777C10.2441 7.2915 10.2441 5.70858 9.26777 4.73223"
                                            fill="#8f8f8f"
                                        />
                                    </svg>
                                </span>
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="" style={{ right: 0, left: "unset" }}>
                                <ul className="list-unstyled mb-0" style={{ paddingLeft: "19px" }}>
                                    <h5 onClick={() => navigate(MANAGE_COORDINATORS_EDIT.replace(":id", item.id))}
                                        className="cursor-pointer proxima mb-2">
                                        Edit
                                    </h5>
                                    <h5 onClick={(e) => {
                                        e.stopPropagation()

                                        // if (item?.email_verified_at) {

                                        //     setShowAlertModal(true);
                                        //     return;
                                        // };
                                        setModalType("resendAccountActivationMail");
                                        setCurrentEntry(item);
                                        setShowModal(true);
                                    }}
                                        className="cursor-pointer proxima mb-2">
                                        Resend Mail
                                    </h5>
                                    <h5 onClick={() => {
                                        setModalType(item?.status == "active" ? "archive" : "active");
                                        setCurrentEntry(item);
                                        setShowModal(true);
                                    }}
                                        className="cursor-pointer proxima mb-2">
                                        {item?.status == "active" ? "Archive" : "Unarchive"}
                                    </h5>
                                    <h5 onClick={() => {
                                        setCurrentEntry(item);
                                        setModalType("delete");
                                        setShowModal(true);
                                    }}
                                        className="cursor-pointer proxima mb-2">
                                        Delete
                                    </h5>
                                </ul>
                            </Dropdown.Menu>
                        </Dropdown>

                        {
                            item?.status == "complete" && <div
                                className="cursor-pointer d-flex align-items-center"
                                style={{ padding: "10px 10px" }}
                                onClick={(e) => {
                                    e.stopPropagation(); // prevent row navigation
                                    toggleRow(item.id);
                                }}
                            >
                                {openRow === item.id ? (
                                    <img width={12} src={downArrow} alt="Collapse" />
                                ) : (
                                    <img width={7} src={rightArrow} alt="Expand" />
                                )}
                            </div>
                        }
                    </div >
                    {/* <div className="ActnBtn d-flex align-items-center  gap-10">
                        <CommonToolTip
                            text={"Edit"}
                            component={<Button
                                className="p-0"
                                variant="transparent"
                                type="button"
                                onClick={() => navigate(MANAGE_COORDINATORS_EDIT.replace(":id", item.id))}
                            >
                                <EditIcon />
                            </Button>}
                        />
                        <CommonToolTip
                            text={"Resend Mail"}
                            component={<Button
                                className="p-0"
                                variant="transparent"
                                type="button"
                                onClick={(e) => {
                                    e.stopPropagation()

                                    // if (item?.email_verified_at) {

                                    //     setShowAlertModal(true);
                                    //     return;
                                    // };
                                    setModalType("resendAccountActivationMail");
                                    setCurrentEntry(item);
                                    setShowModal(true);
                                }}
                            >
                                <ChatIcon />
                            </Button>}
                        />
                        <CommonToolTip
                            text={item?.status == "active" ? "Archive" : "Unarchive"}
                            component={<Button
                                onClick={() => {
                                    setModalType(item?.status == "active" ? "archive" : "active");
                                    setCurrentEntry(item);
                                    setShowModal(true);
                                }} className="p-0"
                                variant="transparent"
                                type="button"
                            >
                                {item?.status == "active" ? <ArchiveIcon /> : <UnArchiveIcon />}
                            </Button>}
                        />
                        <CommonToolTip
                            text={"Delete"}
                            component={<Button
                                className="p-0"
                                variant="transparent"
                                type="button"
                                onClick={() => {

                                    setCurrentEntry(item);
                                    setModalType("delete");
                                    setShowModal(true);
                                }}
                            >
                                <DeleteIcon />
                            </Button>}
                        />
                    </div> */}
                </>
            ),
        },
    ]

    const handleFilterChange = (key) => (value) => {
        dispatch(coordinatorsFilter({ ...filter, [key]: value }))
        setCurrentPage(1);
    }

    const handlePageChange = (page) => {
        window.scrollTo(0, 0);
        setCurrentPage(page);
    };

    const resetFilter = () => {
        dispatch(coordinatorsFilter({ search: "", status: "active", sort: { column: "id", direction: "desc" } }));
        setCurrentPage(1)
    };

    const handleArchive = async () => {

        try {

            setShowModal(false);

            const list = [...coordinatorsList];
            const index = coordinatorsList?.findIndex(x => x.id === currentEntry?.id);
            list[index] = { ...list[index], status: list[index].status == "active" ? "archived" : "active" };
            setCoordinatorsList(list.filter(Boolean));

            const result = await archiveCoordinator(currentEntry?.id);
            refetch();
            if (!result?.error) successMessageToast("Record has been updated successfully.");

        } catch (err) { console.error("error archiving parent", err); };
    };

    const handleResendMail = async () => {
        try {

            setShowModal(false);

            let result = await resendAccountActivation({ id: currentEntry?.id }).unwrap();
            successMessageToast(result?.message);

        } catch (err) {
            console.log("error resend activation mail", err);
        }
    };

    const handleSearchChange = useCallback(debounce((value) => {
        setCurrentPage(1);
        handleFilterChange("search")(value);
    }, 500), [handleFilterChange, 500]);

    useLayoutEffect(() => {

        if (data?.records) setCoordinatorsList(data?.records)
    }, [data]);

    return (
        <>
            <AlertPop
                confirmation={showAlertModal}
                setConfirmation={setShowAlertModal}
                message={"The account has been already verified"}
            />
            <ConfirmationPop
                confirmation={showModal}
                setConfirmation={setShowModal}
                confirmHandler={modalType == "delete" ? handleDelete : modalType == "resendAccountActivationMail" ? handleResendMail : handleArchive}
                type={modalType}
            />
            <section className="ManageDiscriplines position-relative py-4">
                <Container fluid={true}>
                    <Row>
                        <Col lg="12" className="my-2">
                            <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                                <div className="left classroom-conslutation">
                                    <h6 className="m-0 fw-bold main-head themeBlue">Coordinators</h6>
                                </div>
                                <div className="right">
                                    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                                        <li className="">
                                            <Link to={MANAGE_COORDINATORS_ADD} className="blue-discharge-screen-btn mt-0 d-flex align-items-center justify-content-center">
                                                Add New Coordinator
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className="reports-v2 my-3 d-flex justify-content-end classroom-conslutation">
                        <Col md='3'>
                            <div className="d-flex align-items-center w-100 gap-3">
                                <label className="discharge-screen-label mb-0">Status</label>
                                <CommonSelect
                                    placeholder={"Select"}
                                    option={STATUS_OPTIONS}
                                    onChange={(e) => handleFilterChange("status")(e)}
                                    value={filter?.status}
                                    isFilterV2
                                    isClearable
                                    // isLoading={schoolListLoading || schoolListFetching}
                                    styles={{
                                        container: (provided) => ({
                                            ...provided,
                                            width: "100%", // ✅ Ensures the whole Select container is full width
                                        }),
                                    }}
                                />
                            </div>
                        </Col>
                        <Col lg="3" >
                            <div className="d-flex align-items-center w-100 gap-3">
                                <label className="discharge-screen-label mb-0">Search</label>
                                <input
                                    onChange={(e) => handleSearchChange(e.target.value)}
                                    // style={{outline: "blue"}}
                                    className={`input-new readonly-box h-auto search-input-filter-v2`}
                                    placeholder="Find a client..."
                                    defaultValue={filter?.search}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="12" className="my-2">
                            {/* <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                                <div className="left">
                                    <TableHeader
                                        heading={"Coordinators Profile"}
                                        handleFilterChange={handleFilterChange}
                                        resetFilter={resetFilter}
                                        filter={filter}
                                        searchPlaceholder="Email, First, Last Name"
                                    />
                                </div>
                                <div className="right">
                                    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                                        <li className="">
                                            <Link
                                                to={MANAGE_COORDINATORS_ADD}
                                                className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                                            >
                                                <span className="icn me-1">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="19"
                                                        height="19"
                                                        viewBox="0 0 19 19"
                                                        fill="none"
                                                    >
                                                        <mask
                                                            id="mask0_0_4440"
                                                            style={{ maskType: "alpha" }}
                                                            maskUnits="userSpaceOnUse"
                                                            x="0"
                                                            y="0"
                                                            width="19"
                                                            height="19"
                                                        >
                                                            <rect
                                                                width="18.7197"
                                                                height="18.7197"
                                                                fill="#D9D9D9"
                                                            />
                                                        </mask>
                                                        <g mask="url(#mask0_0_4440)">
                                                            <path
                                                                d="M8.57996 13.2594H10.1399V10.1394H13.2599V8.57947H10.1399V5.45951H8.57996V8.57947H5.46V10.1394H8.57996V13.2594ZM9.35995 17.1593C8.28096 17.1593 7.26698 16.9546 6.31799 16.5451C5.369 16.1356 4.54352 15.5799 3.84153 14.8779C3.13954 14.1759 2.58379 13.3504 2.1743 12.4014C1.76481 11.4524 1.56006 10.4384 1.56006 9.35946C1.56006 8.28047 1.76481 7.26649 2.1743 6.3175C2.58379 5.36851 3.13954 4.54303 3.84153 3.84104C4.54352 3.13905 5.369 2.58331 6.31799 2.17381C7.26698 1.76432 8.28096 1.55957 9.35995 1.55957C10.4389 1.55957 11.4529 1.76432 12.4019 2.17381C13.3509 2.58331 14.1764 3.13905 14.8784 3.84104C15.5804 4.54303 16.1361 5.36851 16.5456 6.3175C16.9551 7.26649 17.1598 8.28047 17.1598 9.35946C17.1598 10.4384 16.9551 11.4524 16.5456 12.4014C16.1361 13.3504 15.5804 14.1759 14.8784 14.8779C14.1764 15.5799 13.3509 16.1356 12.4019 16.5451C11.4529 16.9546 10.4389 17.1593 9.35995 17.1593ZM9.35995 15.5994C11.1019 15.5994 12.5774 14.9949 13.7864 13.7859C14.9954 12.5769 15.5999 11.1014 15.5999 9.35946C15.5999 7.61748 14.9954 6.142 13.7864 4.93302C12.5774 3.72404 11.1019 3.11955 9.35995 3.11955C7.61797 3.11955 6.14249 3.72404 4.93351 4.93302C3.72453 6.142 3.12004 7.61748 3.12004 9.35946C3.12004 11.1014 3.72453 12.5769 4.93351 13.7859C6.14249 14.9949 7.61797 15.5994 9.35995 15.5994Z"
                                                                fill="white"
                                                            />
                                                        </g>
                                                    </svg>
                                                </span>{" "}
                                                Add New Teacher
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div> */}
                            <div className="table-outer">
                                {isLoading ? (
                                    <div style={{ height: "200px" }}>
                                        <LoadingIndicator />
                                    </div>
                                ) : isError ? (
                                    <ErrorComponent />
                                ) : (
                                    <>
                                        {(isFetching || deleteCoordinatorLoading || archiveCoordinatorLoading || resendMailLoading) && (
                                            <LoadingOverlay />
                                        )}
                                        <TableLayoutV2 data={coordinatorsList} column={column} filter={filter} handleSort={handleFilterChange("sort")} />
                                    </>
                                )}
                                <CstmPagination
                                    className='paginationV2'
                                    totalPages={totalPages}
                                    activePage={currentPage}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default ManageCoordinators;
